<script>
    import PlainAccessPN from '/public/components/users/PlainAccessPN.svelte';

</script>
<div class="container-fluid">
    <div class="row justify-content-center mt-5">
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-4 col-xxl-4">

            <PlainAccessPN/>

        </div>
    </div>
</div>
